import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    ctaContinue: 'Continue',
    documentName: 'proof_of_funds',
    title: 'Add proof of funds',
  },
  fr: {
    ctaContinue: 'Continuer',
    documentName: 'preuve_de_fonds',
    title: 'Ajoutez une preuve de fonds',
  },
} as const);
